import React, { useState, useEffect } from "react";
import { Avatar, Tooltip } from "@mui/joy";
import { api } from "../../utils/axios-instance";
import useAuth from "../../stores/authStore";
import { useDarkMode } from "../../context/darkModeContext";

// images from public folder
const MobileIcon = `${process.env.PUBLIC_URL}/assets/MobileIcon.webp`;
const Desktopicon = `${process.env.PUBLIC_URL}/assets/Desktopicon.webp`;

const DeviceInfo = () => {
  const [users, setUsers] = useState([]);
  const profileData = useAuth((s) => s.profileData);
  const { darkMode } = useDarkMode();

  useEffect(() => {
    const listUsers = async () => {
      try {
        const res = await api.get(`/users/list_users`);
        const others = Array.isArray(res.data) ? res.data : [];

        // Include current user (Device page is useful even in single-user org)
        const me = profileData ? { ...profileData } : null;

        const merged = me
          ? [me, ...others.filter((u) => u?.id !== me?.id)]
          : others;

        setUsers(merged);
      } catch (error) {
        console.log(error);
        setUsers(profileData ? [profileData] : []);
      }
    };

    listUsers();
  }, [profileData]);

  return (
    <div className="py-3 px-5">
      <hr
        className={`
 border
 ${darkMode ? "border-slate-700" : "border-b-[#D8DEE4]"}
 `}
      />

      <div>
        {users.length ? (
          users.map((user) => {
            const deviceType = user?.metadata?.deviceType || "Unknown";
            const devices = user?.metadata?.devices || "Unknown";

            return (
              <div
                key={user.id}
                className={`my-3 p-4 rounded-2xl flex flex-row justify-between items-center border border-slate-700 ${darkMode ? "bg-[#1E293B]" : "bg-[#f7f7ff]"}`}
              >
                <span className="flex flex-row gap-3 items-center">
                  <Tooltip title={user.email} arrow>
                    <Avatar
                      alt={user.first_name}
                      src={user.profilePictureUrl}
                      variant="soft"
                      sx={{ width: 40, height: 40 }}
                    />
                  </Tooltip>

                  <div className="flex flex-col">
                    <p
                      className={`${darkMode ? "text-white font-semibold" : "font-semibold"}`}
                    >
                      {user?.first_name} {user?.last_name}
                    </p>
                    <p
                      className={`text-sm ${darkMode ? "text-slate-400" : "text-gray-600"}`}
                    >
                      {user?.email}
                    </p>
                  </div>
                </span>

                <span className="flex flex-row items-center gap-4">
                  <img
                    src={deviceType === "Desktop" ? Desktopicon : MobileIcon}
                    alt="device"
                    className="w-8 h-8"
                  />

                  <div className="flex flex-col">
                    <p
                      className={`${darkMode ? "text-white font-semibold" : "font-semibold"}`}
                    >
                      {deviceType}
                    </p>
                    <p
                      className={`text-sm ${darkMode ? "text-slate-400" : "text-gray-600"}`}
                    >
                      {devices}
                    </p>
                  </div>
                </span>
              </div>
            );
          })
        ) : (
          <div className="text-center py-8 text-gray-500">
            No devices found.
          </div>
        )}
      </div>
    </div>
  );
};

export default DeviceInfo;
